<!--
 * @Description:
 * @Version: 1.0
 * @Autor: zsw
 * @Date: 2022-04-20 13:49:44
 * @LastEditors: 姚林刚
 * @LastEditTime: 2023-07-17 15:48:49
-->
<template>
  <div id="mapContainer" class="mapContainer">
    <div id="map" class="map"></div>
  </div>
</template>
<script>
import Vue from 'vue';
import { TileSuperMapRest, LayerStatus, SetLayerStatusParameters, LayerInfoService } from "@supermap/iclient-ol";
import Map from "ol/Map";
import { Tile as TileLayer } from "ol/layer";
import View from "ol/View";
import Feature from "ol/Feature";
import { Point, Polygon } from "ol/geom";
import WMTSTileGrid from 'ol/tilegrid/WMTS'
import {
  XYZ, WMTS
}
from 'ol/source';
import { Style, Icon, Stroke, Circle, Fill, Text } from "ol/style";
import VectorSource from "ol/source/Vector";
import { Vector as VectorLayer } from "ol/layer";
const GIS_MAP = {
  city_410928000: "https://gis-server.chiaic.com/iserver/services/map-ZuoYangXianTeXiaoDiTu/rest/maps/濮阳县L11-L14_GD_TX",
};
// 乡界线
const GIS_MAP_EDGE = {
  city_410928000: 'https://gis-server.chiaic.com/iserver/services/map-AIDaPing/rest/maps/濮阳县_AI大屏_边界',
  city_411121000: '舞阳县GIS_MAP_EDGE_FAKE_URL',
  city_410526000: '滑县GIS_MAP_EDGE_FAKE_URL',
  city_410225000: '兰考县GIS_MAP_EDGE_FAKE_URL',
};
import { mapGetters } from "vuex";
import * as homeApi from "@/api/home";
import { debounce } from "@/utils/index";
import Overlay from 'ol/Overlay';
import { 
  // seasonProgress as SeasonProgressDataApi,
  seasonProgressWithCoordinates as SeasonProgressDataApi,
  getAreaLonAndLat as AreaLonAndLatApi,
} from '@/api/workInfo';
import ProgressionFlag from './ProgressionFlag.vue';

export default {
  name: "mapContainer",
  props: {
    // 农机品类 0全部 1收获类机械 2播种类机械 3插秧类机械 4耕整类机械 5植保类机械 6收获后处理机械 7其他机械
    machineryType: {
      type: [Number, String],
      default: 0,
    },
    progressSwitchSelected: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    const unselectedStyle = {
      stroke: new Stroke({
        color: "rgba(255, 13, 13, 1)",
        width: 1,
      }),
      fill: new Fill({
        color: "rgba(255, 13, 13, 1)",
      }),
    };
    const selectedStyle = {
      stroke: new Stroke({
        color: "rgba(255, 255, 154, .3)",
        width: 1,
      }),
      fill: new Fill({
        color: "rgba(255, 255, 154, .3)",
      }),
    };
    return {
      polygonSource: null,
      unselectedStyle,
      selectedStyle,
      layers: {
        infoPointLayer: null,
        provinceLayer: null,
        pointLayer: null,
        polygonLayer: null,
      },
      // 是否已显示gis地址名称
      isAddressNameShow: false,
      // 地图中心点
      mapCenter: [115.12, 35.59],
      // 地图层级
      mapZoom: 11.0,
      // 定位终端188作业轨迹
      url188: '',
      // 定位终端199作业轨迹
      url199: '',
      list199: [],
      list188: [],
      // 收割进度图
      seasonProgresses: {
        // '35.565507, 115.298471': { areaId: '410928206', value: 0.1, areaName: '白堽乡' },
        // '115.012265, 35.464447': { areaId: '410928101', value: 0.2, areaName: '海通乡' },
      },
    };
  },
  computed: {
    ...mapGetters(["getactiveRegionObj", "season"]),
    seasonName() {
      let self = this;
      const v = self.season;
      const dict = { SX:'三夏', SQ:'三秋' };
      const name = dict[v] || '季度';
      return name;
    },
  },
  watch: {
    progressSwitchSelected(v) {
      let self = this;
      if (v) {
        self.map.getView().setZoom(self.mapZoom);
        self.getSeasonProgress();
      } else {
        self.clearProgressIcons();
        self.map.removeLayer(self.layers.countyLayer);
      }
    },
    $route: {
      handler(v) {
        let self = this;
        if (v.path == '/work_info') {
          const area = self.$store.state.activeRegionObj || {};
          // 添加乡镇边界线
          self.addEdge(`city_${area.areaCode}`);
        }
      },
    },
    machineryType: {
      handler(v) {
        let self = this;
        console.log('农机品类', `[${v}]农机品类 0全部 1收获类机械 2播种类机械 3插秧类机械 4耕整类机械 5植保类机械 6收获后处理机械 7其他机械`)
        self.getSeasonProgress();
      },
      immediate: true,
    },
  },
  methods: {
    // 全县三夏三秋机收完成进度
    getSeasonProgress() {
      let self = this;
      if (!self.progressSwitchSelected) {
        console.log('%c跳过加载地图上的「作业进度.收割完成进度」', 'color:#C00', { progressSwitchSelected: self.progressSwitchSelected });
        return;
      }
      typeof self.getSeasonProgress_cancel === 'function' && self.getSeasonProgress_cancel(); // 取消上一个请求以用参数重新获取
      const params = {
        createAreaCode: self.getactiveRegionObj.areaCode,
        machineryType: self.machineryType || 0,
      };
      self.$emit('seasonProgressLoading', true);
      const promise = SeasonProgressDataApi(params);
      self.getSeasonProgress_cancel = promise.cancel || (() => {});
      promise
        .then((res) => {
          console.log('%c全县三夏三秋机收完成进度.res', 'color:#CC0', JSON.parse(JSON.stringify(res)), { params });
          self.seasonProgresses = res || {};
        })
        .catch((res) => {
          console.log('全县三夏三秋机收完成进度.err', res);
          self.seasonProgresses = [];
        })
        .finally(() => {
          self.$emit('seasonProgressLoading', false);
          // 请求到数据后如果仍旧是选中状态则显示
          if (self.progressSwitchSelected) {
            self.setProgressIcons();
          }
          const area = self.$store.state.activeRegionObj || {};
          self.addEdge(`city_${area.areaCode}`); // 下级区域边界线
        })
    },
    // 在地图上显示进度图标
    setProgressIcons() {
      let self = this;
      // 先清除已有的预警图标
      self.clearProgressIcons();
      // 增加
      let progressionIcons = [];
      const Content = Vue.extend(ProgressionFlag);
      for (const lnglat in self.seasonProgresses) {
        if (Object.prototype.hasOwnProperty.call(self.seasonProgresses, lnglat)) {
          const progress = self.seasonProgresses[lnglat];
          let element = new Content({
            propsData: {
              data: progress,
              // clickCallback: self.showProgressDetail,
            },
          }).$mount();
          const position = lnglat.split(/,\s*/);
          const icon = new Overlay({
            position,
            element: element.$el,
            offset: [0, 10],
            stopEvent: true,
          });
          icon.set('_key', lnglat);
          icon.set('_instance', element); // 用于调用内部方法来清除选中状态
          icon.setPositioning('bottom-center');
          icon.getElement().parentNode.style.zIndex = 1001;
          progressionIcons.push(icon);
          // console.log('在地图上显示进度图标', lnglat, { areaName: progress.areaName, progress: progress.progress, warning: progress.warning });
        }
      }
      // console.log('在地图上显示进度图标', progressionIcons);
      if (progressionIcons.length > 0) {
        progressionIcons.forEach((icon, i) => {
          self.map.addOverlay(icon);
          // console.log('add', i, icon);
        });
      }
    },
    // 清除地图上的所有进度图标
    clearProgressIcons() {
      let self = this;
      const overlays = self.map.getOverlays().getArray();
      overlays.slice().forEach((overlay, i) => {
        // console.log('remove:', i, t, overlay);
        self.map.removeOverlay(overlay);
      });
    },
    showProgressDetail(item) {
      console.log('showProgressDetail', item);
      let self = this;
      self.$emit('progress', item);
    },
    // 获取定位终端188轨迹分布点
    async getWmtsUrl188(year = 2025) {
      if(!this.list188 || this.list188.length <= 0) {
        await homeApi.getDictData('wmts_url_188').then((res) => {
          this.list188 = res || []; 
        });
      }
      let findData = this.list188 && this.list188.length>0 ? this.list188.find(v=>{return v.dictLabel == year}):null;
      const url = findData && findData.dictValue ? findData.dictValue : '';
      const code = this.getactiveRegionObj.areaCode.replace(/0+$/, '');
      this.url188 = url + code;
    },
    // 获取定位终端188轨迹分布点
    async getWmtsUrl199(year = 2025) {
      if(!this.list199 || this.list199.length <= 0) {
        await homeApi.getDictData('wmts_url_199').then((res) => {
          this.list199 = res || []; 
        });
      }
      let findData = this.list199 && this.list199.length>0 ? this.list199.find(v=>{return v.dictLabel == year}):null;
      const url = findData && findData.dictValue ? findData.dictValue : '';
      const code = this.getactiveRegionObj.areaCode.replace(/0+$/, '');
      this.url199 = url + code;

    },
    /** 添加乡镇指示标识 */
    setTownship(arr = []) {
      this.areaAllowanceList = arr;
      if(this.townshipLayer) this.map.removeLayer(this.townshipLayer);
      let source = new VectorSource();
      arr.map(v=>{
        let iconFeature = new Feature({
          geometry: new Point([v.longitude, v.latitude]),
          feature_type: '乡镇统计点',
          ...v
        });
        source.addFeature(iconFeature);
      });
      this.townshipLayer = new VectorLayer({
        zIndex:1000,
        source: source,
        style: function (feature, resolution) {
          // 乡镇图表
          return new Style({
            zIndex: 1,
            image: new Icon({
              scale: 0.5,
              anchorOrigin: 'bottom-left',
              offsetY: 0,  // 偏移
              anchorXUnits: "fraction",
              anchorYUnits: "pixels",
              src:  require("../../../assets/images/common/icon_map_xz.png"),
            }),
          });
        }
      });
      this.map.addLayer(this.townshipLayer);
    },
    /** 显示地图图层 */
    showMapLayer() {
      let this_ = this;
      let ortherAddressNameGroup = new LayerStatus({
          layerName: "LayerGroup",  
          isVisible: true // 控制显示隐藏地址名称
      });
      let layerStatus = new LayerStatus({
          layerName: "蒙版@濮阳县_TX",
          isVisible: true // 控制显示隐藏地址名称
      });
      let setLayerStatusParameters = new SetLayerStatusParameters({
          layerStatusList: [ortherAddressNameGroup, layerStatus]
      });
      new LayerInfoService(this.$utils.formatUrl("https://gis-server.chiaic.com/iserver/services/map-ZuoYangXianTeXiaoDiTu/rest/maps/濮阳县L11-L14_GD_TX")).setLayerStatus(setLayerStatusParameters, function (e) {
        console.log('e :>> ', e);
          this_.map.removeLayer(this_.addressNameTileLayer);
          let tempLayerID = e.result.newResourceID;
          this_.addressNameTileLayer = new TileLayer({
            zIndex:1,
            source: new TileSuperMapRest({
                url: this_.$utils.formatUrl("https://gis-server.chiaic.com/iserver/services/map-ZuoYangXianTeXiaoDiTu/rest/maps/濮阳县L11-L14_GD_TX"),
                url: this_.$utils.formatUrl("https://gis-server.chiaic.com/iserver/services/map-ZuoYangXianTeXiaoDiTu/rest/maps/濮阳县L11-L14_GD_TX"),
                cacheEnabled: true,
                layersID: tempLayerID
            }),
            projection: 'EPSG:4326'
          });
          this_.map.addLayer(this_.addressNameTileLayer);
      });
    },
    /***
     * 加图层
     * @return {Promise<void>}
     */
    async initLayers() {
      //行政区划边界图层
      this.layers.provinceLayer = new VectorLayer({
        renderMode: "vector",
        source: new VectorSource(),
        zIndex: 1,
        rotation: 2,
      });
      this.map.addLayer(this.layers.provinceLayer);
      this.polygonSource = new VectorSource();
      let polygonStyle = new Style(this.unselectedStyle);

      this.layers.polygonLayer = new VectorLayer({
        source: this.polygonSource,
        zIndex: 9999, // 设置多边形的图层在最上方
        style: polygonStyle,
      });
      this.map.addLayer(this.layers.polygonLayer);
    },
    // 某县的区划边界网
    addEdge(city) {
      // 此功能废弃：采用「兰考县」的作法：直接在底图上显示乡界。底图有张雷更新，不需要这里单独加边界了。
      return;
      const url = GIS_MAP_EDGE[city];
      if (url) {
        this.layers.countyLayer = new TileLayer({
          source: new TileSuperMapRest({
            url,
            cacheEnabled: false,
          }),
          properties: {
            clickable: false, // 设置图层不可点击
          },
          isGroup: true,
          zIndex: 100, // 省市县三级作业进度大屏增加各区域的三夏三秋机收进度数据，数据来源为AI大屏各区域的机收进度数据，把区域边界图层置顶并加粗。（县级需将乡镇边界加上）进度数据边框和字体颜色根据AI大屏的达标是否达标进行区分展示，达标绿色，未达标黄色。
          name: '乡镇边界',
          type: 'baseLyer',
        });
        this.map.addLayer(this.layers.countyLayer);
        console.log('%c乡界已加载', 'color:#CC0', { layer: this.layers.countyLayer, url: GIS_MAP_EDGE[city] });
      } else {
        console.log('%c乡界未加载', 'color:#C00', city, { url: GIS_MAP_EDGE[city] });
      }
    },

    addProvince(city) {
      if (this.layers.provinceLayer.getSource()) {
        this.layers.provinceLayer.getSource().clear();
      }
      let style = null;
      // 濮阳县gis图片
      this.layers.baseLayer.setSource(
        new TileSuperMapRest({
          url: this.$utils.formatUrl(GIS_MAP[city]),
          cacheEnabled: true,
        })
      );
      style = {
        stroke: new Stroke({
          //边框
          color: "rgba(200, 200, 255, 0)",
          width: 1,
        }),
        fill: new Fill({
          //填充
          color: "rgba(200, 200, 255, 0.1)",
        }),
      }
    },
    /** 地图层级变更 */
    checkZoom(zoom) {
      if(zoom<=10.9 || zoom>=11.1) { // 乡镇统计显隐处理
        if(!this.removeTownship) {
          if(this.townshipLayer) { // 避免重复清除
            this.removeTownship = true;
            this.map.removeLayer(this.townshipLayer);
          }
        }
      } else {
        if(this.removeTownship) { // 避免重复加载
          this.removeTownship = false;
          this.setTownship(this.areaAllowanceList);
        }
      }
      let this_ = this;
      if(this.isGroupOrLayer == zoom>=10.6 && this.isMaskShow == zoom>=7 && this.isAddressNameShow == zoom<11.4) return; // 限制不管是隐藏地址名称还是显示，都只执行一次
      this.isGroupOrLayer = zoom>10.6 ? true: false;
      this.isMaskShow = zoom>7 ? true: false;
      this.isAddressNameShow = zoom>=11.4 ? false: true;
      let ortherAddressNameGroup = new LayerStatus({
          layerName: "LayerGroup",
          isVisible: zoom>10.6 ? true: false // 控制显示隐藏地址名称
      });
      let layerStatus = new LayerStatus({
          layerName: "蒙版@濮阳县_TX",
          isVisible: zoom>7 ? true: false // 控制显示隐藏地址名称
      });
      let setLayerStatusParameters = new SetLayerStatusParameters({
          layerStatusList: [ortherAddressNameGroup, layerStatus]
      });
      new LayerInfoService(this.$utils.formatUrl("https://gis-server.chiaic.com/iserver/services/map-ZuoYangXianTeXiaoDiTu/rest/maps/濮阳县L11-L14_GD_TX")).setLayerStatus(setLayerStatusParameters, function (e) {
          this_.map.removeLayer(this_.addressNameTileLayer);
          let tempLayerID = e.result.newResourceID;
          this_.addressNameTileLayer = new TileLayer({
              source: new TileSuperMapRest({
                  url: this_.$utils.formatUrl("https://gis-server.chiaic.com/iserver/services/map-ZuoYangXianTeXiaoDiTu/rest/maps/濮阳县L11-L14_GD_TX"),
                  url: this_.$utils.formatUrl("https://gis-server.chiaic.com/iserver/services/map-ZuoYangXianTeXiaoDiTu/rest/maps/濮阳县L11-L14_GD_TX"),
                  cacheEnabled: true,
                  layersID: tempLayerID
              }),
              projection: 'EPSG:4326'
          });
          this_.map.addLayer(this_.addressNameTileLayer);
      });
    },
    initBaseLayer() {
      this.map = new Map({
        target: "map",
        layers: [
          new TileLayer({
            source: new XYZ({
              // url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&lang=zh_cn&size=1&scl=1&style=6'
              url: 'https://t{0-7}.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TileCol={x}&TileRow={y}&TileMatrix={z}&tk=1d109683f4d84198e37a38c442d68311'
            }),
            isGroup: true,
            name: '高德图路网'
          }),
          new TileLayer({
            zIndex:10,
            source: new TileSuperMapRest({
              url: this.$utils.formatUrl('https://gis-server.chiaic.com/iserver/services/map-QuanGuoXingZhengQuHuaShuJu/rest/maps/全国矢量数据'),
              url: this.$utils.formatUrl('https://gis-server.chiaic.com/iserver/services/map-QuanGuoXingZhengQuHuaShuJu/rest/maps/全国矢量数据'),
              cacheEnabled: true,

            }),
            isGroup: true,
            name: "全国省矢量",
            type: "baseLyer",
          }),
          new TileLayer({
            zIndex:10,
            source: new TileSuperMapRest({
              url: this.$utils.formatUrl('https://gis-server.chiaic.com/iserver/services/map-QuanGuoXingZhengQuHuaShuJu/rest/maps/全国省界'),
              url: this.$utils.formatUrl('https://gis-server.chiaic.com/iserver/services/map-QuanGuoXingZhengQuHuaShuJu/rest/maps/全国省界'),
              cacheEnabled: true,

            }),
            isGroup: true,
            name: "全国省界",
            type: "baseLyer",
          })
        ],
        view: new View({
          center: this.mapCenter,
          zoom: this.mapZoom,
          projection: "EPSG:4326",
          maxZoom: 14,
          minZoom: 6,
        }),
      });
      this.layers.baseLayer = new TileLayer({
        source: new TileSuperMapRest({
          url: "",
          cacheEnabled: true,

        }),
        isGroup: true,
        zIndex: 0,
        name: "高清影像图",
        type: "baseLyer",
      });
      this.map.addLayer(this.layers.baseLayer);
      this.showMapLayer(this.map.getView().getZoom());
      this.setTownship();
      // 监听hover
      this.map.on("pointermove", (e) => {
        let pixel = this.map.getEventPixel(e.originalEvent);
        let currentFeature = this.map.forEachFeatureAtPixel(
          pixel,
          function (feature, layer) {
            return feature;
          }
        );
        if(currentFeature && currentFeature.values_ && currentFeature.values_.feature_type == '乡镇统计点') {
          let info = {
            x: e.originalEvent.x,
            y: e.originalEvent.y,
            ...currentFeature.values_
          }
          this.$emit("townshipPoint", true, info);
        } else {
          this.$emit("townshipPoint", false);
        }
      })
      this.checkZoom(this.map.getView().getZoom());
      this.map.getView().on('change:resolution', () => {
        this.checkZoom(this.map.getView().getZoom());
        const zoom = this.map.getView().getZoom();
        this.$emit('zoomed', zoom);
        if (zoom != this.mapZoom && this.progressSwitchSelected) {
          console.log('缩放改变', { zoom, defaultZoom: this.mapZoom });
          // 收割进度数据仅在初始层级展示，地图放大缩小或点击作业类型切换都将自动关闭收割进度开关。手动打开开关将自动把地图重置到初始地图层级。
          this.clearProgressIcons();
          this.$emit('update:progressSwitchSelected', false);
          // this.$message({
          //   message: `因「地图缩放」，已关闭「${this.seasonName}收割进度」。`,
          //   type: 'warning',
          //   duration: 2000,
          // });
          console.log(`因「地图缩放」，已关闭「${this.seasonName}收割进度」`);
        }
      });
    },
    removeWorkLayer(){
      this.workInfo = {};
      if(this.worKTileLayer) {
        this.map.removeLayer(this.worKTileLayer);
      }
      if(this.positionTileLayer) {
        this.map.removeLayer(this.positionTileLayer);
      }
    },
    // 生产海量点
    createWmts(wmtsUrl) {
      return new WMTS({
          url: wmtsUrl,
          // layer: layer,
          matrixSet: "EPSG:4326", // 矩阵集，通常为 EPSG:4326 或 EPSG:3857
          format: "image/png", // 图片格式
          projection: "EPSG:4326", // 投影坐标系
          tileGrid: new WMTSTileGrid({
            origin: [-180, 90], // 瓦片原点
            resolutions: [
              0.703125, 0.3515625, 0.17578125, 0.087890625, 0.0439453125,
              0.02197265625, 0.010986328125, 0.0054931640625, 0.00274658203125,
              0.001373291015625, 0.0006866455078125, 0.00034332275390625,
              0.000171661376953125, 0.0000858306884765625, 0.00004291534423828125,
            ],
            matrixIds: [
              "EPSG:4326:0",
              "EPSG:4326:1",
              "EPSG:4326:2",
              "EPSG:4326:3",
              "EPSG:4326:4",
              "EPSG:4326:5",
              "EPSG:4326:6",
              "EPSG:4326:7",
              "EPSG:4326:8",
              "EPSG:4326:9",
              "EPSG:4326:10",
              "EPSG:4326:11",
              "EPSG:4326:12",
              "EPSG:4326:13",
              "EPSG:4326:14",
            ],
          }),
          style: "", // 样式
        });
    },
    // 海量点分布
    async wmtsPointLayer(jobType = null, workTypes, statisticsYear) {
        // 解决重复加载gis问题
        if(this.wmtsInfo && this.wmtsInfo.jobType == jobType && this.wmtsInfo.workTypes == workTypes && this.wmtsInfo.statisticsYear == statisticsYear) return;
        this.wmtsInfo = {
          jobType: jobType,
          workTypes: workTypes,
          statisticsYear: statisticsYear
        }
        if(workTypes.length > 0 && !workTypes.some(v => { return v == '188' })) workTypes.push('188');
        if(workTypes.length > 0 && !workTypes.some(v => { return v == '199' })) workTypes.push('199');
        await this.getWmtsUrl199(statisticsYear);
        await this.getWmtsUrl188(statisticsYear);
        
        console.log('wmtsPointLayer.jobType::', jobType);
        console.log('wmtsPointLayer.workTypes::', workTypes);
        if(this.wmtsLayer188) {
          this.map.removeLayer(this.wmtsLayer188);
        }
        if(this.wmtsLayer199) {
          this.map.removeLayer(this.wmtsLayer199);
        }
        // wmts
        let wmtsUrl188 = null;
        let wmtsUrl199 = null;
        let wmtsSource188 = null;
        let wmtsSource199 = null;

        wmtsUrl188 = this.url188;
        wmtsUrl199 = this.url199;



        if(jobType == null || jobType == undefined) {
          if(workTypes.indexOf('188') > -1 && workTypes.indexOf('199') > -1) {
            // 创建 WMTS 来源
            wmtsSource199 = this.createWmts(wmtsUrl199);
            // 创建图层
            this.wmtsLayer199 = new TileLayer({
              source: wmtsSource199,
              zIndex: 8,
            });
            this.map.addLayer(this.wmtsLayer199);

            // 创建 WMTS 来源
            wmtsSource188 = this.createWmts(wmtsUrl188);
            console.log('wmtsSource188', wmtsSource188);
            // 创建图层
            this.wmtsLayer188 = new TileLayer({
              source: wmtsSource188,
              zIndex: 8,
            });
            this.map.addLayer(this.wmtsLayer188);
          }else if(workTypes.indexOf('188') > -1 && workTypes.indexOf('199') == -1) {
            // 创建 WMTS 来源
            wmtsSource188 = this.createWmts(wmtsUrl188);
            // 创建图层
            this.wmtsLayer188 = new TileLayer({
              source: wmtsSource188,
              zIndex: 8,
            });
            this.map.addLayer(this.wmtsLayer188);
          }else if(workTypes.indexOf('188') == -1 && workTypes.indexOf('199') > -1){
            // 创建 WMTS 来源
            wmtsSource199 = this.createWmts(wmtsUrl199);
            // 创建图层
            this.wmtsLayer199 = new TileLayer({
              source: wmtsSource199,
              zIndex: 8,
            });
            this.map.addLayer(this.wmtsLayer199);
          }else {
            wmtsUrl188 = null;
            wmtsUrl199 = null;
            if(this.wmtsLayer188) {
              this.map.removeLayer(this.wmtsLayer188);
            }
            if(this.wmtsLayer199) {
              this.map.removeLayer(this.wmtsLayer199);
            }
          }
        }else if(jobType == 188) {
            // 创建 WMTS 来源
            wmtsSource188 = this.createWmts(wmtsUrl188);
            // 创建图层
            this.wmtsLayer188 = new TileLayer({
              source: wmtsSource188,
              zIndex: 8,
            });
            this.map.addLayer(this.wmtsLayer188);
        }else if(jobType == 199) {
            // 创建 WMTS 来源
            wmtsSource199 = this.createWmts(wmtsUrl199);
            // 创建图层
            this.wmtsLayer199 = new TileLayer({
              source: wmtsSource199,
              zIndex: 8,
            });
            this.map.addLayer(this.wmtsLayer199);
        }else {
          wmtsUrl188 = null;
          wmtsUrl199 = null;
          if(this.wmtsLayer188) {
            this.map.removeLayer(this.wmtsLayer188);
          }
          if(this.wmtsLayer199) {
            this.map.removeLayer(this.wmtsLayer199);
          }
        }

    },
    // 移出海量点展示
    removeWmtsPointLayer(){
      this.wmtsInfo = null;
      if(this.wmtsLayer188) {
        this.map.removeLayer(this.wmtsLayer188);
      }
      if(this.wmtsLayer199) {
        this.map.removeLayer(this.wmtsLayer199);
      }
    },
    workLayer(createAreaCode, jobType, otherParams = {}) {
      const jobTypeList = Array.isArray(jobType) ? jobType.map(item => item !== undefined && item !== null ? String(item) : '').filter(item => item !== '') : [];
      const singleJobType = !Array.isArray(jobType) && jobType ? String(jobType) : '';
      const hasJobType = Array.isArray(jobType) ? jobTypeList.length > 0 : !!singleJobType;
      const hasWorkJobType = hasJobType && (Array.isArray(jobType) ? jobTypeList.some(item => item != '188' && item != '199') : singleJobType != '188' && singleJobType != '199');
      const hasPositionJobType = hasJobType && (Array.isArray(jobType) ? jobTypeList.some(item => item == '188' || item == '199') : singleJobType == '188' || singleJobType == '199');
      // 解决重复加载gis问题
      if(this.workInfo && this.workInfo.createAreaCode == createAreaCode && this.workInfo.jobType == jobType && this.workInfo.otherParams == otherParams) return;
      this.workInfo = {
        createAreaCode: createAreaCode,
        jobType: jobType,
        otherParams: otherParams
      }
      console.log('workLayer.jobType ', jobType);
      console.log('otherParams :>> ', otherParams);
      this.worKTileLayerurl = this.$utils.formatUrl('https://gis-server.chiaic.com/iserver/services/map-job_plot_workspace-2/rest/maps/job_plot_data_map');
      let searchData = ""
      if (createAreaCode) {
        if (createAreaCode.slice(0,4) === 'city') {
          createAreaCode = createAreaCode.split("_")[1]
        }
        const province = createAreaCode.slice(0,2); // 省
        const city = createAreaCode.slice(0,4); // 市
        const county = createAreaCode.slice(0,6); // 县
        // viewArea-isJobArea
        // 智能农机在本县 0-3
        // 本县农机在本县 3-3
        // 本县农机在本市 3-2
        // 本县农机在本省 3-1
        // 本县农机在全国 3-0

        // 智能农机在濮阳县作业数据
        if(otherParams.viewArea == 0 && otherParams.isJobArea == 3) {
          searchData = searchData+ `job_area_code Like'${county}%'`
        } 
        // 濮阳县农机在濮阳县作业数据
        if(otherParams.viewArea == 3 && otherParams.isJobArea == 3) {
          searchData = searchData+ `car_area_code Like'${county}%' And job_area_code Like'${county}%'`
        }
        // 濮阳县农机在濮阳市作业数据
        if(otherParams.viewArea == 3 && otherParams.isJobArea == 2) {
          searchData = searchData+ `car_area_code Like'${county}%' And job_area_code Like'${city}%'`
        }
        // 濮阳县农机在河南省作业数据
        if(otherParams.viewArea == 3 && otherParams.isJobArea == 1) {
          searchData = searchData+ `car_area_code Like'${county}%' And job_area_code Like'${province}%'`
        }
        // 濮阳县农机在全国作业数据
        if(otherParams.viewArea == 3 && otherParams.isJobArea == 0) {
          searchData = searchData+ `car_area_code Like'${county}%' And car_area_code Like'${county}%'`
        }
      }
      // 作业类型
      if (hasJobType) {
        // if(jobType == '13') searchData = searchData+ " And (job_type_code ='13' Or job_type_code ='108')"
        // else searchData = searchData+ " And job_type_code ='"+jobType+"'"
        if(Array.isArray(jobType)) {
          searchData = searchData+ " And job_type_code In ("+jobTypeList.map(item => "'" + item.replace(/'/g, "''") + "'").join(',')+")"
        }else {
          searchData = searchData+ " And job_type_code ='"+singleJobType.replace(/'/g, "''")+"'"
        }
      }
      let layerName = "";
      let positionLayerName = '';
      this.worKTileLayerurl = '';
      this.positionTileLayerurl = '';
      // 年份
      if(otherParams.viewYear == 2022) {
        this.worKTileLayerurl = this.$utils.formatUrl('https://gis-server.chiaic.com/iserver/services/map-2022NianNongJiYunDiKuaiFuWu/rest/maps/2022年农机云地块')
        this.worKTileLayerurl = this.$utils.formatUrl('https://gis-server.chiaic.com/iserver/services/map-2022NianNongJiYunDiKuaiFuWu/rest/maps/2022年农机云地块')
        layerName = "农机云地块2022@2022年农机云地块2#1"
      } else if (otherParams.viewYear == 2023) {
        this.worKTileLayerurl = this.$utils.formatUrl('https://gis-server.chiaic.com/iserver/services/map-job_plot_workspace-2/rest/maps/job_plot_data_map')
        this.worKTileLayerurl = this.$utils.formatUrl('https://gis-server.chiaic.com/iserver/services/map-job_plot_workspace-2/rest/maps/job_plot_data_map')
        layerName = "job_plot@job_plot_data_map"
      } else if (otherParams.viewYear == 2024) {
        if(otherParams.type == 0) {
          if(!hasJobType) {
            // 两种地块
            this.worKTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-job_plot_data_2024/rest/maps/job_plot_data_2024')
            layerName = "job_plot@job_plot_data_2024#2"
            this.positionTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-job_plot_data_2024/rest/maps/plot_dw')
            positionLayerName = "job_plot_dw@job_plot_data_2024" 
          }
          if(hasWorkJobType) {
            this.worKTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-job_plot_data_2024/rest/maps/job_plot_data_2024')
            layerName = "job_plot@job_plot_data_2024#2"
          }
          if(hasPositionJobType) {
            this.positionTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-job_plot_data_2024/rest/maps/plot_dw')
            positionLayerName = "job_plot_dw@job_plot_data_2024" 
          }
        }
        if(otherParams.type == 1) {
          // 作业终端地块
          this.worKTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-job_plot_data_2024/rest/maps/job_plot_data_2024');
          layerName = "job_plot@job_plot_data_2024#2";
        }
        if(otherParams.type == 2) {
          // 定位终端地块
          this.positionTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-job_plot_data_2024/rest/maps/plot_dw');
          positionLayerName = "job_plot_dw@job_plot_data_2024" ;
        }
      }else if (otherParams.viewYear == 2025) {
        if(otherParams.type == 0) {
          if(!hasJobType) {
            // 两种地块
            this.worKTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-NongJiYunDiKuai2025/rest/maps/job_plot_data_2025')
            layerName = "job_plot@农机云地块2025#1"
            this.positionTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-NongJiYunDiKuai2025/rest/maps/plot_dw_2025')
            positionLayerName = "job_plot_dw@农机云地块2025#1" 
          }
          if(hasWorkJobType) {
            this.worKTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-NongJiYunDiKuai2025/rest/maps/job_plot_data_2025')
            layerName = "job_plot@农机云地块2025#1"
          }
          if(hasPositionJobType) {
            this.positionTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-NongJiYunDiKuai2025/rest/maps/plot_dw_2025')
            positionLayerName = "job_plot_dw@农机云地块2025#1" 
          }
        }
        if(otherParams.type == 1) {
          // 作业终端地块
          this.worKTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-NongJiYunDiKuai2025/rest/maps/job_plot_data_2025');
          layerName = "job_plot@农机云地块2025#1";
        }
        if(otherParams.type == 2) {
          // 定位终端地块
          this.positionTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-NongJiYunDiKuai2025/rest/maps/plot_dw_2025');
          positionLayerName = "job_plot_dw@农机云地块2025#1" ;
        }
      } else {
        if(otherParams.type == 0) {
          if(!hasJobType) {
            // 两种地块
            this.worKTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-job_plot_data/rest/maps/job_plot_data')
            layerName = "job_plot@job_plot_data_2025"
            this.positionTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-job_plot_data/rest/maps/plot_dw')
            positionLayerName = "job_plot_dw@job_plot_data_2025" 
          }
          if(hasWorkJobType) {
            this.worKTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-job_plot_data/rest/maps/job_plot_data')
            layerName = "job_plot@job_plot_data_2025"
          }
          if(hasPositionJobType) {
            this.positionTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-job_plot_data/rest/maps/plot_dw')
            positionLayerName = "job_plot_dw@job_plot_data_2025" 
          }
        }
        if(otherParams.type == 1) {
          // 作业终端地块
          this.worKTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-job_plot_data/rest/maps/job_plot_data');
          layerName = "job_plot@job_plot_data_2025";
        }
        if(otherParams.type == 2) {
          // 定位终端地块
          this.positionTileLayerurl = this.$utils.formatUrl('https://gis2-server.chiaic.com/iserver/services/map-job_plot_data/rest/maps/plot_dw');
          positionLayerName = "job_plot_dw@job_plot_data_2025" ;
        }
      }
      let this_ = this;
      if(this.worKTileLayerurl) {
        this_.workLayerStatus = new LayerStatus({
            layerName: layerName,
            isVisible: true,
            displayFilter: searchData  //不设置表示控制子图层显隐，设置表示控制子图层下面的单值的显示
        });
        var setLayerStatusParameters = new SetLayerStatusParameters({
            layerStatusList: [this_.workLayerStatus]
        });
        new LayerInfoService(this_.worKTileLayerurl).setLayerStatus(setLayerStatusParameters, function (e) {
            this_.map.removeLayer(this_.worKTileLayer);
            var tempLayerID = e.result.newResourceID;
            this_.worKTileLayer = new TileLayer({
                zIndex:10,
                source: new TileSuperMapRest({
                    url: this_.worKTileLayerurl,
                    cacheEnabled: true,
                    layersID: tempLayerID
                }),
                projection: 'EPSG:4326'
            });
            this_.map.addLayer(this_.worKTileLayer);
        });
      }else {
        if(this.worKTileLayer) {
          this.map.removeLayer(this.worKTileLayer);
        }
      }

      // 定位终端地块
      if(this.positionTileLayerurl && (otherParams.type == 0 || otherParams.type == 2)) {
        if(!hasJobType || hasPositionJobType) {
          this_.positionLayerStatus = new LayerStatus({
            layerName: positionLayerName,
            isVisible: true,
            displayFilter: searchData  //不设置表示控制子图层显隐，设置表示控制子图层下面的单值的显示
          });
          let setLayerStatusParameters = new SetLayerStatusParameters({
            layerStatusList: [this_.positionLayerStatus]
          });
          new LayerInfoService(this_.positionTileLayerurl).setLayerStatus(setLayerStatusParameters, function (e) {
            this_.map.removeLayer(this_.positionTileLayer);
            var tempLayerID = e.result.newResourceID;
            this_.positionTileLayer = new TileLayer({
                zIndex:10,
                source: new TileSuperMapRest({
                    url: this_.positionTileLayerurl,
                    cacheEnabled: true,
                    layersID: tempLayerID
                }),
                projection: 'EPSG:4326'
            });
            this_.map.addLayer(this_.positionTileLayer);
          });
        }
      }else{
        if(this.positionTileLayer) {
          this.map.removeLayer(this.positionTileLayer);
        }
      }

    }
  },
  mounted() {
    this.initBaseLayer();
    this.initLayers();
    this.getWmtsUrl188();
    this.getWmtsUrl199();
  },
};
</script>
<style lang="scss">
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
.mapContainer {
  width: 100%;
  height: 100%;
  position: relative;
}
.ol-zoom.ol-unselectable.ol-control {
  display: none;
}
.map {
  width: 100%;
  height: 100%;
}
.ol-rotate {
  display: none;
}
</style>
